<template>
	<div class="bill_template template_102 gridall fullpage" :data-no-translate="!$root.invoicePrintInSelectedLanguage || null" :class="{[templateClass]: true, 'font_small':invoiceFieldsObj.fontSize.value=='small', 'font_large':invoiceFieldsObj.fontSize.value=='large' && !$root.TransactionSettings.fullPagePrint, 'font_xl':invoiceFieldsObj.fontSize.value=='xl' && !$root.TransactionSettings.fullPagePrint, 'font_xxl':invoiceFieldsObj.fontSize.value=='xxl' && !$root.TransactionSettings.fullPagePrint}">

		<div id="printArea">
			<div class="page fullpage" id="page_1">

				<div class="header">
					<table style="text-align:left;height:100%">
						<thead class="primary-header noborder">
							<tr center-align>
								<td colspan="3"><div><u>{{data.invoiceTitle}}</u></div></td>
							</tr>

							<tr right-align v-if="!data.status">
								<td colspan="3" redcolor>Cancelled!</td>
							</tr>

							<tr>
								<td colspan="3" class="business_row">

									<div class="col67" :class="{'hasLogo':!preview && data.templateSettings.businessLogo && $root.CurrentBusiness.businessLogo && fn_showSection(invoiceFieldsObj.businessLogo.status)}">
										<div class="business_logo mr-2" v-ripple :class="{'editable':isEditable, 'fade-opacity':!invoiceFieldsObj.businessLogo.status}" v-if="data.templateSettings.businessLogo && $root.CurrentBusiness.businessLogo && fn_showSection(invoiceFieldsObj.businessLogo.status)" @click="fn_editLogo">
											<img :src="$root.CurrentBusiness.businessLogo"/>
											<div class="editabled-field-label" v-if="isEditable"><v-icon>edit</v-icon> Logo</div>
										</div>

										<div class="business_logo" :class="{'editable':isEditable}" @click="fn_editLogo" white-background v-if="(!data.templateSettings.businessLogo || !$root.CurrentBusiness.businessLogo) && isEditable">	
											<div style="text-align: center;padding: 18px 0px;font-size: 10px;">Logo</div>
											<div class="editabled-field-label" v-if="isEditable"><v-icon>add</v-icon> Logo</div>
										</div>

										<div style="clear:both;width:48px;float: left;" class="pt-0" v-if="isEditable && data.templateSettings.businessLogo && $root.CurrentBusiness.businessLogo">
											<v-switch class="hide-margins small-switch mt-1" hide-details :height="17"  nopadding v-model="invoiceFieldsObj.businessLogo.status"></v-switch>
										</div>

										<div class="business_details" style="display: grid;" :class="{'nopadding': (!data.templateSettings.businessLogo || !$root.CurrentBusiness.businessLogo || !invoiceFieldsObj.businessLogo.status) && !isEditable, 'pl-2':!preview && (data.templateSettings.businessLogo || $root.CurrentBusiness.businessLogo)}">
											<div v-html="header.data.content" v-ripple v-if="header.data && header.data.content" :class="{'editable':isEditable}" @click="fn_editPrintField(header.fieldId)"></div>
											<div class="editabled-field-label" v-if="isEditable"><v-icon>edit</v-icon> Business Details</div>
										</div>
									</div>

									<div class="col33" right-align>
										<template v-if="data.invoiceTitle!='Journal'">
											<strong>No.</strong>: {{data.transactionNumber}}<br>
											<strong>Date</strong>: 
											<template v-if="$root.TransactionSettings.invoiceDateFormat">
												{{ data.transactionDate | moment($root.TransactionSettings.invoiceDateFormat) }}
											</template>
											<template v-else>
												{{ data.transactionDate | moment("DD-MMM-YYYY") }}
											</template>
										</template>
									</div>	
								</td>
							</tr>
						</thead>
					</table>
				</div>

				<table class="items_table">
					<tbody class="noborder items_body">

						<template v-if="data.invoiceTitle=='Journal'">
							<tr>
								<td style="width:50%"><strong>No.</strong>: {{data.transactionNumber}}</td>
								<td style="width:50%" right-align colspan="2"><strong>Date</strong>: 
									<template v-if="$root.TransactionSettings.invoiceDateFormat">
										{{ data.transactionDate | moment($root.TransactionSettings.invoiceDateFormat) }}
									</template>
									<template v-else>
										{{ data.transactionDate | moment("DD-MMM-YYYY") }}
									</template>
								</td>
							</tr>

							<tr class="items_header border-bottom border-top">
								<td style="width:50%" class="border-right"><strong>Particulars</strong></td>
								<td style="width:25%" right-align><strong>By (Dr)</strong></td>
								<td style="width:25%" right-align><strong>To (Cr)</strong></td>
							</tr>

							<tr v-for="(item, index) in data.transactionLedgers" :key="index">
								<td class="border-right">{{item.name}}
									<div v-for="(ref, refIndex) in item.references" v-if="item.references && item.references.length && (data.transactionListId == 30001 || data.transactionListId == 30002)">
										Invoice No.: {{ref.transactionNumber ? ref.transactionNumber : ref.referenceNumber}} Dated: {{ref.transactionDate | moment("DD-MMM-YYYY")}}
									</div>
									<div v-if="item.bankDetails">
										<span v-if="item.bankDetails.bankName">Bank Name: {{item.bankDetails.bankName}}</span>&nbsp;
										<span v-if="item.bankDetails.refNumber">Ref Number: {{item.bankDetails.refNumber}}</span>&nbsp;
										<span v-if="item.bankDetails.refDate">Ref Date: {{item.bankDetails.refDate | moment("DD-MMM-YYYY")}}</span>&nbsp;
										<span v-if="item.bankDetails.transType">Type: {{item.bankDetails.transType}}</span>
									</div>
								</td>
								<td right-align><span v-if="item.amountType==1">&#8377;</span> {{item.amountType == 1 ? $root.numberToLocale(item.amount) : ''}}</td>
								<td right-align><span v-if="item.amountType==0">&#8377;</span> {{item.amountType == 0 ? $root.numberToLocale(item.amount) : ''}}</td>
							</tr>

							<tr class="items_footer border-top border-bottom">
								<td class="border-right"><strong>Total</strong></td>
								<td right-align><strong>&#8377; {{$root.numberToLocale(data.roundedAmount)}}</strong></td>
								<td right-align><strong>&#8377; {{$root.numberToLocale(data.roundedAmount)}}</strong></td>
							</tr>

							<tr>
								<td colspan="3">
									<strong>Amount (in words)</strong>: {{convertNumberToWords(data.roundedAmount)}} only.
								</td>
							</tr>
						</template>

						<template v-else>
							<tr class="border-top">
								<td colspan="2">
									<div font-medium>{{data.invoiceTitle == 'Receipt' ? 'Received From' : 'Paid To'}}</div>
									<div><span font-medium>Name</span>: {{data.partyDetails[0].partyName}}</div>
									<div v-if="data.partyDetails[0].primaryMobileNumber"><span font-medium>Mobile</span>: {{data.partyDetails[0].primaryMobileNumber}}</div>

									<div v-for="(item, index) in data.transactionLedgers">
										<div v-for="(ref, refIndex) in item.references">
											<v-layout row wrap pl-3 pt-1>
												<template v-if="ref.isAgainstRef">
													<v-flex xs2 sm2 md2>
														Ref: {{ ref.transactionNumber }}
													</v-flex>

													<v-flex xs4 sm4 md4>
														{{ fn_getPrefix(ref.transactionListId) == 'minus' ? '(-)' : '' }}
														&#8377; {{$root.numberToLocale(ref.amount)}}
													</v-flex>
												</template>

												<template v-if="ref.isOnAccount">
													<v-flex xs2 sm2 md2>
														On Account
													</v-flex>

													<v-flex xs4 sm4 md4>
														&#8377; {{$root.numberToLocale(ref.amount)}}
													</v-flex>
												</template>

												<template v-if="ref.referenceNumber">
													<v-flex xs12 sm12 md12>
														Bill No.: {{ ref.referenceNumber }}
													</v-flex>
												</template>
											</v-layout>
										</div>
									</div>
								</td>

								<td>
									<div class="right-column nopadding right-align">
										<div font-medium>Amount</div>
										<div>(&#8377;) {{$root.numberToLocale(data.roundedAmount)}}</div>
									</div>
								</td>
							</tr>

							<tr class="border-top">
								<td colspan="3" class="single-column-double-section">
									<div class="left-column nopadding">
										<div font-medium class="pb-1">{{data.invoiceTitle == 'Contra' ? 'Mode' : 'Payment Mode'}}</div>
										<div v-for="(item, index) in data.transactionLedgers" :key="index" v-if="item.name != data.partyDetails[0].partyName">
											<div><span font-medium>{{item.name}}</span>: &#8377; {{$root.numberToLocale(item.amount)}}</div>
										</div>
									</div>
								</td>
							</tr>

							<tr class="border-top">
								<td colspan="3" class="single-column-double-section">
									<div class="left-column nopadding">
										<div font-medium class="pb-1">Amount (in words)</div>
										<div>{{convertNumberToWords(data.roundedAmount)}} only.</div>
									</div>
								</td>
							</tr>

							<tr class="border-top" v-if="$root.TransactionSettings.showPartyBalance">
								<td colspan="3" class="single-column-double-section">
									<div class="left-column nopadding">
										<div font-medium class="pb-1" v-if="data.lastInvoice">
											<span font-medium>Previous Balance</span>: &#8377; {{$root.numberToLocale(fn_previousBalance())}}
										</div>
										<div font-medium>
											<span font-medium>Current Balance</span>: &#8377; {{$root.numberToLocale(data.partyDetails[0].currentBalance)}}
										</div>
									</div>
								</td>
							</tr>
						</template>

						<tr class="border-top" v-if="data.notes && $root.TransactionSettings.enableCustomerSignature && (data.transactionListId == 30001 || data.transactionListId == 30002)">
							<td colspan="3">
								<strong>Note</strong><br>
								{{data.notes}}
							</td>
						</tr>

						<tr :class="{'border-top':data.invoiceTitle!='Journal'}">
							<td colspan="3" class="single-column-double-section" :class="{'pt-3':isEditable}">
								<div class="left-column nopadding" v-if="$root.TransactionSettings.enableCustomerSignature && (data.transactionListId == 30001 || data.transactionListId == 30002)">
									<div>
										<strong>Customer's Signature</strong><br>
										<div style="height: 80px;border: 1px solid #999;"></div>
									</div>
								</div>

								<div class="left-column nopadding" v-else>
									<div v-if="data.notes">
										<strong>Note</strong><br>
										{{data.notes}}	
									</div>
								</div>

								<div full-height nopadding class="right-column bottom-right-column" :class="{'editable pt-2':isEditable}">
									<template v-if="fn_showSection(invoiceFieldsObj.signatory.status)">
										<div full-height :class="{'fade-opacity':!invoiceFieldsObj.signatory.status, 'pt-2':!signatory.data}" @click="fn_editPrintField(signatory.fieldId, 'signature')">
											<div right-align class="signatory" v-ripple v-html="signatory.data.content" v-if="signatory.data && signatory.data.content"></div>
											<div class="editabled-field-label" v-if="isEditable"><v-icon>add</v-icon> Signature</div>
										</div>	
									</template>
								</div>

								<div class="pt-2 pb-2 mt-2" v-if="isEditable && signatory.data && signatory.data.content">
									<v-switch class="hide-margins small-switch float-right mt-1 mb-0 ml-0" hide-details :height="17"  nopadding v-model="invoiceFieldsObj.signatory.status"></v-switch>
								</div>
							</td>
						</tr>
					</tbody>
				</table>

				<div class="fullpage_footer">
					<table>
						<tr class="noborder" :class="{'row-app-logo':isEditable}" v-if="fn_showSection(brandLogo.showInPrintOut)">
							<td right-align class="noborder" colspan="3">
								<div class="invoice-footer" :class="{'fade-opacity': !brandLogo.showInPrintOut}">
									<div class="branding grey-back" style="position:relative">
										<v-btn @click="fn_toggleBrandLogo(false, 1)" v-if="!isEditable" style="border-radius: 4px;height: 18px;padding: 0px 8px 0px 6px;background: #fff;position: absolute;top: -19px;right: 0px;border: 1px #ddd solid;min-width: auto !important;" color="primary" capitalize flat class="ma-0 mt-1 remove-logo-btn"><v-icon style="font-size: 10px !important;" class="mr-1" color="primary">close</v-icon> Remove</v-btn>
										<a href="https://bizopsapp.com/" target="_blank">
											<div class="branding-box">
												<div class="dark-opacity-color powered">Powered By</div>
												<div class="title primary-color">
													<img class="brand_logo" src="../../../assets/BizOpsApp_Icon_24x24.png" alt="bizops_logo">BizOps App
												</div>
											</div>
										</a>
									</div>
								</div>
								<div class="pb-2 pt-2" v-if="isEditable">
									<v-switch class="hide-margins small-switch float-right mr-2 mt-0 mb-0 ml-0" hide-details :height="17" v-model="brandLogo.showInPrintOut"  nopadding @change="fn_toggleBrandLogo"></v-switch>
								</div>
							</td>
						</tr>
					</table>
				</div>

			</div>
		</div>

	</div>
</template>

<script>

const transactionTypes = require('../../../config.js').configs.transactionTypes;

export default{
	props:['data', 'preview', 'isEditable', 'editBusiness', 'editLogo', 'editPrintField'],
	data(){
		return{
			headers:[{"name":"Particulars", "width":67}, {"name":"Amount", "width":33}],
			items:[],
			header:{data:null, fieldId:null, showInPrintOut:true},
			signatory:{data:null, fieldId:null, showInPrintOut:true},
			logoField:{data:null, fieldId:null, showInPrintOut:false},
			invoiceFieldsObj:{
                "businessLogo": {"fieldId":"businessLogo", "sectionName":"Business Logo",  "status":true, "groupName":"businessFields", "defaultStatus":true},
                "signatory": {"fieldId":"signatory", "sectionName":"signatory", "status":true, "groupName":"PrintField", "defaultStatus":true},
				"fontSize": {"value":"medium", "sectionName":"Font Size"}
            },
			brandLogo:{showInPrintOut:true},
		}
	},
	computed:{
		templateClass(){
			return 'template_' + (this.data.templateSettings ? this.data.templateSettings.invoiceTemplate : '');
		}
	},
	methods:{
		fn_showSection: function(showInPrintOut){
			if(this.isEditable){
				return true;
			}
			else{
				if(showInPrintOut){
					return true;
				}
				else{
					return false;
				}
			}
		},

		fn_toggleBrandLogo: function(val, fromPreview){
            let dataObj = {};
            dataObj.LocalKey = 'bizopslogo_visibility';
            dataObj.LocalValue = val;
            this.$root.fn_saveLocalData(dataObj);

            fromPreview ? this.brandLogo.showInPrintOut = val : '';

			this.fn_getToken(val);
        },

        fn_getToken: function(val){
            if(this.$root.appVersion < 104){
				return;
			}
            this.$root.fn_getAuthToken(token=>{
                this.fn_brandLogoToServer(val, token);
            });
        },

        fn_brandLogoToServer: function(val, token){
            if(!navigator.onLine){
                return;
            }
            
            let dataObj = {};
            dataObj.businessId = this.$root.CurrentBusiness.BusinessID;
            dataObj.token = token;

            let fnName = val ? "EnableLogo" : "RemoveLogo";
            this.getServerData(fnName, dataObj, 
                {
                onSuccess: function(response){
                    console.log(response);
                }, 
                onError: function(error){
                    console.log(error);
                }, 
                }
            );
        },

		fn_editPrintField(fieldId, type){
			this.editPrintField ? this.editPrintField(fieldId, type) : '';
		},

		fn_editBusiness(){
			this.editBusiness ? this.editBusiness() : '';
		},

		fn_editLogo(){
			this.editLogo ? this.editLogo() : '';
		},

		fn_previousBalance: function(){
            if(this.data.lastInvoice && this.data.lastInvoice.onCredit){
                let prefix = this.fn_getPrefix(this.data.lastInvoice.transactionListId) == 'minus' ? '-' : '';
                return prefix + this.data.lastInvoice.onCredit;
            }
            else{
                return 0;
            }
        },

        fn_getPrefix: function(transactionListId){
            let prefix = '';
            let result = transactionTypes.find(item => item.id == transactionListId);
            prefix = result && result.prefix ? result.prefix : '';
            return prefix;
        },

		fn_init: function(callback){
			let configItems = null;

            if(localStorage.getItem("template_settings")){
                let dataObj = JSON.parse(localStorage.getItem("template_settings"));
                configItems = dataObj.configItems && dataObj.configItems.length ? dataObj.configItems : null;
            }
            else if(this.data && this.data.templateSettings && this.data.templateSettings.visibilityConfig){
                let obj = JSON.parse(this.data.templateSettings.visibilityConfig);
                configItems = obj['configItems_'+this.data.invoiceTitle];
            }

            if(configItems && configItems.length){
                for(let i=0; i<configItems.length; i++){
                    for(let [key, value] of Object.entries(this.invoiceFieldsObj)){
                        if(key == configItems[i].fieldId){
                            this.invoiceFieldsObj[key].status = configItems[i].status;
                        }
                    }
                }
            }

		},

		convertNumberToWords: function(num) {
			let result = this.$root && this.$root.fn_amountInWords ? this.$root.fn_amountInWords(num) : num;
			return result;
		},
	},
	mounted(){
		this.fn_init();

		if(localStorage.getItem('bizopslogo_visibility')){
			this.brandLogo.showInPrintOut = JSON.parse(localStorage.getItem('bizopslogo_visibility'));
		}
	}
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/invoice_templates/invoices/template102.vue